(function (global) {
  'use strict';

  class PMSBeltBuilderShopify {
    constructor(root) {
      this.root = root;
    }

    readJson(selector) {
      const node = this.root.querySelector(selector);
      if (!node) return null;
      try { return JSON.parse(node.textContent); }
      catch (error) {
        console.error('[PMS Belt Builder] Invalid embedded JSON.', error);
        return null;
      }
    }

    imageUrl(value) {
      if (!value) return '';
      if (typeof value === 'string') return value;
      return value.src || value.url || '';
    }

    normalizeProduct(raw) {
      if (!raw) return null;
      const productImage = this.imageUrl(raw.featuredImage || raw.featured_image || raw.images?.[0]);
      return {
        id: raw.id == null ? '' : String(raw.id),
        handle: raw.handle || '',
        title: raw.title || '',
        featuredImage: productImage,
        options: (raw.options || []).map((option) => typeof option === 'string' ? option : option?.name || ''),
        variants: (raw.variants || []).map((variant) => ({
          id: String(variant.id),
          title: variant.title || '',
          options: Array.isArray(variant.options)
            ? variant.options.map(String)
            : [variant.option1, variant.option2, variant.option3].filter((value) => value != null).map(String),
          price: Number(variant.price) || 0,
          available: Boolean(variant.available),
          inventoryQuantity: variant.inventoryQuantity ?? variant.inventory_quantity ?? null,
          inventoryPolicy: variant.inventoryPolicy ?? variant.inventory_policy ?? null,
          inventoryManagement: variant.inventoryManagement ?? variant.inventory_management ?? null,
          image: this.imageUrl(variant.image || variant.featured_image) || productImage,
          sku: variant.sku || '',
        })),
      };
    }

    loadPrograms() {
      const raw = this.readJson('[data-pms-belt-catalog]') || { programs: [] };
      return (raw.programs || []).map((program) => ({
        id: String(program.id || ''),
        title: program.title || 'Belt',
        badge: program.badge || '',
        description: program.description || '',
        warranty: program.warranty || '',
        catalog: {
          buckles: (program.buckles || []).map((item) => this.normalizeProduct(item)).filter(Boolean),
          straps: (program.straps || []).map((item) => this.normalizeProduct(item)).filter(Boolean),
        },
      })).filter((program) => program.id);
    }

    toShopifyItem(item) {
      const meta = item.metadata || {};
      const properties = {
        _pms_belt_builder_id: meta.beltId || '',
        _pms_belt_program_id: meta.programId || '',
        _pms_belt_component: item.component || '',
        'Belt program': meta.programTitle || '',
        'Belt sizing': meta.sizing || '',
      };
      if (meta.finalSale) properties['Custom-cut belt final sale'] = meta.finalSale;
      return { id: item.variantId, quantity: item.quantity, properties };
    }

    async addCartPlan(plan, afterAdd = 'cart') {
      const cartUI = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const payload = { items: plan.items.map((item) => this.toShopifyItem(item)) };
      if (afterAdd === 'drawer' && cartUI?.getSectionsToRender) {
        const sections = cartUI.getSectionsToRender().map((section) => section.id).filter(Boolean);
        if (sections.length) {
          payload.sections = sections;
          payload.sections_url = global.location.pathname;
        }
      }
      const rootValue = global.Shopify?.routes?.root || '/';
      const root = rootValue.endsWith('/') ? rootValue : `${rootValue}/`;
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      const text = await response.text();
      let data = {};
      try { data = text ? JSON.parse(text) : {}; } catch (_) { data = { description: text }; }
      if (!response.ok) throw new Error(data.description || data.message || `Shopify could not add the belt (error ${response.status}).`);
      if (afterAdd === 'drawer' && cartUI?.renderContents && data.sections) {
        data.id = data.id || data.items?.[0]?.key || data.items?.[0]?.id;
        cartUI.renderContents(data);
      } else {
        global.location.assign(`${root}cart`);
      }
      return data;
    }
  }

  global.PMSBeltBuilderShopify = PMSBeltBuilderShopify;
})(typeof window !== 'undefined' ? window : globalThis);
